import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-banker-group-modal-statement',
  templateUrl: './banker-group-modal-statement.component.html',
  styleUrls: ['./banker-group-modal-statement.component.scss']
})
export class BankerGroupModalStatementComponent implements OnInit {

  public data: any = {};
  public statements: any = [];
  @Input() banker_group_uuid: string;
  @Output() closeEvent = new EventEmitter<boolean>();
  constructor(private http: HttpService) { 
  }
  ngOnInit(): void {
    this.init();
  }
  async init() {

    let rtn:any = await this.http.post("/admin/banker-group/get-statement", {banker_group_uuid: this.banker_group_uuid, date_from: this.data.date_from, date_to: this.data.date_to});
    if(!rtn.status) {
      this.http.notify(rtn.message);
      return;
    }
    this.statements = rtn.statements;
  }

  close() {
    this.closeEvent.emit(false);
  }

  sum(key: string) {
    return this.statements.reduce((acc: number, statement: any) => acc + statement[key], 0);
  }

}
